import { render, staticRenderFns } from "./project-detail-rate.vue?vue&type=template&id=1c903202&scoped=true&"
import script from "./project-detail-rate.vue?vue&type=script&lang=js&"
export * from "./project-detail-rate.vue?vue&type=script&lang=js&"
import style0 from "./project-detail-rate.vue?vue&type=style&index=0&id=1c903202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c903202",
  null
  
)

export default component.exports